'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  landingPageEvent,
  NewAgainFeelNewAgainSectionModel,
  NewAgainLandingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

type Props = { data: NewAgainFeelNewAgainSectionModel }

export const NewAgainFeelNewAgainSection = ({ data: { title, ctaText, ctaLink } }: Props) => {
  const { track } = useTracking()

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: NewAgainLandingPageEvent.SecondCtaClick,
        targetDetails: ctaLink,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section data-testid="inspiration-section" className="new-again__feel-new-section">
      <h3 className="new-again__feel-new-headline">{title}</h3>
      <div className="new-again__feel-new-cta">
        <Button
          url={ctaLink}
          styling="filled"
          inverse
          onClick={handleOnCtaClick}
          testId="feel-new-section-cta"
        >
          {ctaText}
        </Button>
      </div>
    </section>
  )
}
